<template>
    <CRow>
        <CCol>
            <CCard>
                <CCardHeader>
                    <strong>Шаблоны сообщений в чатах</strong>
                </CCardHeader>
                <CCardBody>
                    <CRow class="pb-3">
                        <CCol sm="12">
                            <CButton color="primary" @click="create">Создать</CButton>
                        </CCol>
                    </CRow>
                    <CRow class="pl-3">
                        <table class="table">
                            <thead>
                                <th></th>
                                <th>Название</th>
                                <th>Текст</th>
                                <th></th>
                            </thead>
                            <draggable v-model="list" tag="tbody">
                                <tr v-for="item in list" :key="item.id">
                                    <td>
                                        <CIcon
                                            :height="24"
                                            :content="$options.icons.cilCursorMove"
                                            class="handle"
                                        />
                                    </td>
                                    <td>{{ item.title }}</td>
                                    <td class="quick-reply-body-preview">{{ item.body }}</td>
                                    <td>
                                        <CButton @click="edit(item.id)">
                                            <CIcon :content="$options.icons.cilPencil" class="handle" />
                                        </CButton>
                                        <CButton @click="removeConfirmation(item.id)">
                                            <CIcon :content="$options.icons.cilTrash" class="handle" />
                                        </CButton>
                                    </td>
                                </tr>
                            </draggable>
                        </table>
                    </CRow>
                </CCardBody>
                <CCardFooter>
                    <CButton
                        color="primary"
                        class="mr-3"
                        @click="save"
                    >
                        Сохранить порядок
                    </CButton>
                    <CButton
                        color="light"
                        class="mr-3"
                        @click="goBack"
                    >
                        Отмена
                    </CButton>
                </CCardFooter>
            </CCard>
        </CCol>

        <CModal
            :title="createEditModalTitle"
            :show.sync="createEditModal.visible"
            :footer="false"
        >
            <template>
                <div slot="body-wrapper" class="modal-body">
                    <CForm>
                        <CRow form class="form-group">
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label"
                            >
                                Название
                            </CCol>
                            <CCol sm="9">
                                <CInput
                                    v-model="createEditModal.item.title"
                                    placeholder="Например: Приветствие"
                                />
                            </CCol>
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label"
                            >
                                Текст
                            </CCol>
                            <CCol sm="9">
                                <CTextarea
                                    v-model="createEditModal.item.body"
                                    rows="6"
                                    placeholder="Текст ответа"
                                />
                                <small class="text-muted d-block mt-2">
                                    Плейсхолдеры:
                                    <code v-pre>{{customer_firstname}}</code>,
                                    <code v-pre>{{customer_lastname}}</code>,
                                    <code v-pre>{{customer_name}}</code>,
                                    <code v-pre>{{customer_phone}}</code>,
                                    <code v-pre>{{order_id}}</code>,
                                    <code v-pre>{{partner_title}}</code>,
                                    <code v-pre>{{chat_title}}</code>
                                </small>
                            </CCol>
                        </CRow>
                    </CForm>
                </div>
                <div slot="footer">
                    <CButton
                        color="light"
                        class="ml-3"
                        @click="createEditModal.visible = false"
                    >
                        Отмена
                    </CButton>
                    <CButton
                        color="primary"
                        class="ml-3"
                        @click="createUpdate"
                    >
                        {{ createEditModalButton }}
                    </CButton>
                </div>
            </template>
        </CModal>

        <CModal
            title="Подтверждение"
            color="danger"
            :show.sync="deleteModal.visible"
            :footer="false"
        >
            <template>
                <div slot="body-wrapper" class="modal-body">
                    <p>Удалить этот шаблон? Действие нельзя отменить.</p>
                </div>
                <div slot="footer">
                    <CButton
                        color="light"
                        class="ml-3"
                        @click="deleteModal.visible = false"
                    >
                        Отмена
                    </CButton>
                    <CButton
                        color="danger"
                        class="ml-3"
                        @click="remove"
                    >
                        Удалить
                    </CButton>
                </div>
            </template>
        </CModal>
    </CRow>
</template>

<script>
    import Vue from 'vue';
    import draggable from 'vuedraggable';
    import { cilCursorMove, cilTrash, cilPencil } from '@coreui/icons';
    import { clearChatQuickReplyCache } from '@/utils/chatQuickReply';

    export default {
        name: 'ChatQuickReplies',
        components: {
            draggable
        },
        data() {
            return {
                list: [],
                createEditModal: {
                    visible: false,
                    editMode: false,
                    editId: 0,
                    item: {
                        title: '',
                        body: ''
                    }
                },
                deleteModal: {
                    visible: false,
                    id: 0
                }
            };
        },
        computed: {
            createEditModalTitle() {
                return this.createEditModal.editMode
                    ? 'Редактирование шаблона'
                    : 'Создание шаблона';
            },
            createEditModalButton() {
                return this.createEditModal.editMode ? 'Сохранить' : 'Создать';
            }
        },
        mounted() {
            this.loadList();
        },
        icons: {
            cilCursorMove,
            cilTrash,
            cilPencil
        },
        methods: {
            async loadList() {
                try {
                    const { data } = await Vue.axios.get('/chat-quick-replies');
                    this.list = data || [];
                } catch (e) {
                    this.$root.$emit('showError', 'Ошибка загрузки данных.');
                }
            },
            create() {
                this.createEditModal.editMode = false;
                this.createEditModal.editId = 0;
                this.createEditModal.item = {
                    title: '',
                    body: ''
                };
                this.createEditModal.visible = true;
            },
            async createUpdate() {
                if (!this.createEditModal.item.title) {
                    this.$root.$emit('showError', 'Название является обязательным.');
                    return;
                }
                if (!this.createEditModal.item.body) {
                    this.$root.$emit('showError', 'Текст является обязательным.');
                    return;
                }

                try {
                    if (this.createEditModal.editMode) {
                        const { data } = await Vue.axios.put(
                            `/chat-quick-replies/${this.createEditModal.editId}`,
                            this.createEditModal.item
                        );
                        this.list = this.list.map(item => (item.id === data.id ? data : item));
                    } else {
                        const { data } = await Vue.axios.post('/chat-quick-replies', this.createEditModal.item);
                        this.list = [...this.list, data];
                    }
                    clearChatQuickReplyCache();
                    this.createEditModal.visible = false;
                } catch (e) {
                    this.$root.$emit('showError', 'Ошибка сохранения.');
                }
            },
            edit(id) {
                const item = this.list.find(entry => entry.id === id);
                if (!item) {
                    return;
                }
                this.createEditModal.editId = id;
                this.createEditModal.editMode = true;
                this.createEditModal.item = {
                    title: item.title,
                    body: item.body
                };
                this.createEditModal.visible = true;
            },
            async save() {
                const reorder = this.list.map((item, index) => ({
                    id: item.id,
                    position: index + 1
                }));
                try {
                    await Vue.axios.post('/chat-quick-replies/reorder', { reorder });
                    clearChatQuickReplyCache();
                    this.$root.$emit('showSuccess', 'Порядок сохранён');
                } catch (e) {
                    this.$root.$emit('showError', 'Ошибка сохранения.');
                }
            },
            removeConfirmation(id) {
                this.deleteModal.id = id;
                this.deleteModal.visible = true;
            },
            async remove() {
                const id = this.deleteModal.id;
                try {
                    await Vue.axios.delete(`/chat-quick-replies/${id}`);
                    this.list = this.list.filter(item => item.id !== id);
                    clearChatQuickReplyCache();
                    this.deleteModal.visible = false;
                } catch (e) {
                    this.$root.$emit('showError', 'Ошибка удаления.');
                }
            },
            goBack() {
                this.$router.push({ path: '/' });
            }
        }
    };
</script>

<style scoped>
.handle {
    cursor: pointer;
}

.quick-reply-body-preview {
    max-width: 420px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
</style>
